<template>
    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
        <div class="ak-panel__header ak-panel__header--small">
            <div class="ak-panel__title">
                <i class="fa fa-truck"></i>
                {{ $t('Laatste aanpassing olieprijs') }}
                <span v-if="prices" class="small"> - {{ prices.dateAdded | date-relative }}</span>
            </div>
        </div>
        <div class="ak-panel__body ak-panel__body--small reading">
            <div class="ak-data-table__table table-candidates">
                <table class="ak-table ak-table--compact ak-panel__table">
                    <thead>
                        <tr class="ak-table-row">
                            <th class="ak-table-head">
                                <span>{{ $t('Aantal liters') }}</span>
                            </th>
                            <th class="ak-table-head">
                                <span>{{ $t('Mazout (Gasolie Extra) prijs') }}</span>
                            </th>
                            <th class="ak-table-head">
                                <span>{{ $t('Mazout Energy+ (Gasolie Extra Energy+) prijs') }}</span>
                            </th>
<!--                            <th class="ak-table-head">-->
<!--                                <span>{{ $t('Mazout Extra Energy+ prijs') }}</span>-->
<!--                            </th>-->
                        </tr>
                    </thead>
                    <tbody v-if="prices" class="ak-table-body">
                        <tr class="ak-table-row">
                            <td class="ak-table-column">
                                <span>1000</span>
                            </td>
                            <td class="ak-table-column">
                                <span>{{ prices.price1000 }}</span>
                            </td>
                            <td class="ak-table-column">
                                <span>{{ prices.price1000plus }}</span>
                            </td>
<!--                            <td class="ak-table-column">-->
<!--                                <span>{{ prices.price1000gasoil }}</span>-->
<!--                            </td>-->
                        </tr>
                        <tr class="ak-table-row">
                            <td class="ak-table-column">
                                <span>2000</span>
                            </td>
                            <td class="ak-table-column">
                                <span>{{ prices.price2000 }}</span>
                            </td>
                            <td class="ak-table-column">
                                <span>{{ prices.price2000plus }}</span>
                            </td>
<!--                            <td class="ak-table-column">-->
<!--                                <span>{{ prices.price2000gasoil }}</span>-->
<!--                            </td>-->
                        </tr>
                    </tbody>
                </table>

                <div class="m-t-15">
                    <ak-button v-if="prices && !prices.dateApproved" @click="approvePrice">
                       {{ $t('Nu goedkeuren') }}
                    </ak-button>
                </div>

                <p v-if="prices && prices.dateApproved">
                    {{ $t('Goedgekeurd') }}: {{ prices.dateApproved | date-relative }} {{ $t('door') }} {{ administrator.firstName }} {{ administrator.surname }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OilPriceTable',
    data() {
      return {
          loading: false,
          isApproved: true,
          prices: null,
          administrator: null,
      }
    },
    methods: {
        async getOilPrices() {
            this.loading = true;
            const result = await this.$get(this.$getSetting('paths.baseCms') + '/product-fuel-prices');
            if (result) {
                this.prices = result.productFuelPrices;
                this.administrator = result.administrator;
            }

            this.loading = false;
        },
        async approvePrice() {
            this.loading = true;
            const result = await this.$post(this.$getSetting('paths.baseCms') + '/product-fuel-prices/approve/' + this.prices.id);
            if (result) {
                this.prices = result.approved;
                this.administrator = result.administrator;
            }

            this.loading = false;
        }
    },
    created() {
        this.getOilPrices();
    }
}
</script>
